import React from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";

import { Breadcrumb, Breadcrumbs } from "@performyard/py-components";

import { useIsNewNavigation } from "../../api/hooks/defs/navigation";

import { parseWorkflowsOrigin } from "../../utils/workflowsBreadcrumbs";

/**
 * Breadcrumbs for the Tornado-rendered view-workflow page; mirrors the Meetings detail page. Portals
 * into the template's `#view-workflow-breadcrumbs` mount and reads its `data-workflow-name`.
 * Renders nothing on the legacy nav.
 */
const ViewWorkflowBreadcrumbs = () => {
	const location = useLocation();
	const isNewNav = useIsNewNavigation();
	const mount = typeof document !== "undefined" ? document.getElementById("view-workflow-breadcrumbs") : null;

	if (!isNewNav || !mount) return null;

	const { from, label } = parseWorkflowsOrigin(location.search);
	const workflowName = mount.getAttribute("data-workflow-name") || "Workflow";

	const items: Breadcrumb[] = [
		{ pageId: "breadcrumb-workflows-origin", name: label, href: from, forceHardReload: true },
		{ pageId: "breadcrumb-view-workflow-current", name: workflowName, href: location.pathname },
	];

	return createPortal(
		<div style={{ padding: "16px 24px 0" }}>
			<Breadcrumbs items={items} />
		</div>,
		mount
	);
};

export default ViewWorkflowBreadcrumbs;
